/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_RightsInputs */

const fr_legal_privacy_rights = /** @type {(inputs: Legal_Privacy_RightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos droits (accès, suppression) peuvent être exercés par mail à`)
};

const en_legal_privacy_rights = /** @type {(inputs: Legal_Privacy_RightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your rights (access, deletion) can be exercised by email at`)
};

/**
* | output |
* | --- |
* | "Your rights (access, deletion) can be exercised by email at" |
*
* @param {Legal_Privacy_RightsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_rights = /** @type {((inputs?: Legal_Privacy_RightsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_RightsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_privacy_rights(inputs)
	return en_legal_privacy_rights(inputs)
});